export default __webpack_public_path__ + "static/media/1851.cb424de3.png";